__turbopack_context__.v({
  "actionPair": "cookie-consent-module__-oHqXG__actionPair",
  "badge": "cookie-consent-module__-oHqXG__badge",
  "banner": "cookie-consent-module__-oHqXG__banner",
  "bannerActions": "cookie-consent-module__-oHqXG__bannerActions",
  "bannerBody": "cookie-consent-module__-oHqXG__bannerBody",
  "bannerCopy": "cookie-consent-module__-oHqXG__bannerCopy",
  "bannerInner": "cookie-consent-module__-oHqXG__bannerInner",
  "bannerIntro": "cookie-consent-module__-oHqXG__bannerIntro",
  "bannerTitle": "cookie-consent-module__-oHqXG__bannerTitle",
  "bullets": "cookie-consent-module__-oHqXG__bullets",
  "button": "cookie-consent-module__-oHqXG__button",
  "buttonLabel": "cookie-consent-module__-oHqXG__buttonLabel",
  "cc-banner-in": "cookie-consent-module__-oHqXG__cc-banner-in",
  "cc-dialog-in": "cookie-consent-module__-oHqXG__cc-dialog-in",
  "cc-fade-in": "cookie-consent-module__-oHqXG__cc-fade-in",
  "close": "cookie-consent-module__-oHqXG__close",
  "dialog": "cookie-consent-module__-oHqXG__dialog",
  "divider": "cookie-consent-module__-oHqXG__divider",
  "essential": "cookie-consent-module__-oHqXG__essential",
  "essentialBody": "cookie-consent-module__-oHqXG__essentialBody",
  "essentialHead": "cookie-consent-module__-oHqXG__essentialHead",
  "essentialTitle": "cookie-consent-module__-oHqXG__essentialTitle",
  "iconTile": "cookie-consent-module__-oHqXG__iconTile",
  "manage": "cookie-consent-module__-oHqXG__manage",
  "option": "cookie-consent-module__-oHqXG__option",
  "optionBody": "cookie-consent-module__-oHqXG__optionBody",
  "optionText": "cookie-consent-module__-oHqXG__optionText",
  "optionTitle": "cookie-consent-module__-oHqXG__optionTitle",
  "outline": "cookie-consent-module__-oHqXG__outline",
  "overlay": "cookie-consent-module__-oHqXG__overlay",
  "panel": "cookie-consent-module__-oHqXG__panel",
  "panelFooter": "cookie-consent-module__-oHqXG__panelFooter",
  "panelHeader": "cookie-consent-module__-oHqXG__panelHeader",
  "panelTitle": "cookie-consent-module__-oHqXG__panelTitle",
  "policyLink": "cookie-consent-module__-oHqXG__policyLink",
  "solid": "cookie-consent-module__-oHqXG__solid",
  "switch": "cookie-consent-module__-oHqXG__switch",
  "switchThumb": "cookie-consent-module__-oHqXG__switchThumb",
});
